<template>
    <div class="table-responsive">
        <table class="table border" aria-label="table-upgrade">
            <thead>
            <tr>
                <th scope="col" style="width: 43%;">Option</th>
                <th scope="col" style="width: 42%;" class="text-center">Value</th>
                <th scope="col" style="width: 15%;" class="text-center">Price</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(service, key) in options" v-if="service.enabled && (service.value || service.price)">
                <td>{{ service.name }}</td>
                <td class="text-center">
                    <span v-if="!key.includes('ShorterTimeInterval') && service.name !== 'Adresseændring'">{{ service.value }}</span>
                    <span v-else-if="service.name === 'Adresseændring'">
                        Name - {{ service.value.name }},
                        Street - {{ service.value.street }},
                        City - {{ service.value.city }},
                        Zip - {{ service.value.zip }},
                        Phone - {{ service.value.phone }}
                    </span>
                    <span v-else>{{ service.value.from }} - {{ service.value.to }}</span>
                </td>
                <td class="text-center">{{ calcPriceExclVat(service.price).toFixed(2) }}</td>
            </tr>
            <tr v-for="(service) in options[primeKey]" v-if="typeof(service) === 'object' && service.enabled">
                <td>{{ service.name }}:</td>
                <td class="text-center"></td>
                <td class="text-center">{{ calcPriceExclVat(service.price).toFixed(2) }}</td>
            </tr>
            <tr v-for="(addOn) in options[addOnsKey]"
                v-if="options[addOnsKey] && addOn.price">
                <td>{{ addOn.name }}:</td>
                <td class="text-center"></td>
                <td class="text-center">{{ calcPriceExclVat(addOn.price).toFixed(2) }}</td>
            </tr>
            <tr>
                <td></td>
                <th scope="row" class="white-space-nowrap text-right"> Total excl. VAT</th>
                <td class="white-space-nowrap text-center">
                    {{ calcTotalExclVatForUpgrade(options).toFixed(2) }}
                </td>
            </tr>
            <tr>
                <td></td>
                <th scope="row" class="white-space-nowrap text-right"> VAT</th>
                <td class="white-space-nowrap text-center">
                    {{ (calcTotalExclVatForUpgrade(options) * vat).toFixed(2) }}
                </td>
            </tr>
            <tr>
                <td></td>
                <th scope="row" class="white-space-nowrap text-right">Total incl. VAT</th>
                <td class="white-space-nowrap text-center">
                    {{ (calcTotalExclVatForUpgrade(options) * (1 + vat)).toFixed(2) }}
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <div class="d-flex align-items-center justify-content-between"
                         v-if="transaction">
                        <strong>Payment details:</strong>
                        <div>
                            <strong>Status:</strong>
                            <span>
                                {{ paymentStatuses[transaction.status] }}
                            </span>
                        </div>
                        <div>
                            <strong>Invoice:</strong>
                            <span>
                                {{ transaction.invoice_guid }}
                            </span>
                        </div>
                        <div>
                            <strong>Date:</strong>
                            <span>
                                {{
                                    transaction ?
                                    formatDateTime(transaction.updated_at) :
                                    ''
                                }}
                            </span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import dateTimeMixin from "../../mixins/dateTimeMixin";

export default {
    name: 'CustomerOptions',
    mixins: [dateTimeMixin],
    props: {
        options: { type: Object|Array, required: true },
        transaction: { type: Object, required: false, default: null },
        primeKey: {type: String, required: true},
        addOnsKey: {type: String, required: true},
        paymentStatuses: {type: Object, required: true},
        priceIncludesVat: {type: Boolean, required: false, default: false},
    },
    data() {
        return {
            vat: 0.25

        }
    },
    methods: {
        calcTotalExclVatForUpgrade(options) {
            let total = 0;
            for (let key in options) {
                if (key === this.primeKey) {
                    for (let k in options[key]) {
                        if (typeof (options[key][k]) === 'object' && options[key][k].enabled) {
                            total += parseFloat(options[key][k].price);
                        }
                    }
                } else if (key === this.addOnsKey) {
                    for (let k in options[key]) {
                        if (typeof (options[key][k]) === 'object') {
                            total += parseFloat(options[key][k].price);
                        }
                    }
                } else if (options[key].enabled) {
                    total += parseFloat(options[key].price);
                }
            }
            return this.priceIncludesVat ? total / (1 + this.vat) : total;
        },

        calcPriceExclVat(price) {
            return this.priceIncludesVat ? price / (1 + this.vat) : price;
        }
    }
}
</script>

<style scoped>
</style>
